import React, { Component } from 'react';

class ButtonLightBlue extends Component {
    render() {
        return (
            <button
                type={this.props.type}
                id={this.props.id}
                onClick={this.props.onClick}
                className={this.props.className + " bg-lightblue rounded border border-lightblue text-white focus:outline-none px-10 py-2"}
            >
                {this.props.children}
            </button>
        );
    }
}

export default ButtonLightBlue;